import {
  inventoryItemIdFormat,
  locationIdFormat,
} from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const getStorageLocationsForTransfer = {
  name: "getStorageLocationsForTransfer" as const,
  input: z.object({
    locationId: locationIdFormat.schema,
    productId: productIdFormat.schema.optional(),
    inStockOnly: z.boolean().optional(),
  }),
  output: z.object({
    bins: z.array(
      z.object({
        storageLocationId: storageLocationIdFormat.schema,
        binName: z.string(),
        binType: z.string(),
        productQuantity: z.number().optional(),
        productOnHand: z.number().optional(),
        productHeld: z.number().optional(),
        inventoryItemId: inventoryItemIdFormat.schema.nullish(),
        class: z.string().nullish(),
        lotNumber: z.string().nullish(),
        expirationDate: z.string().nullish(),
      }),
    ),
  }),
};
